import produce from 'immer';
import { MARK_STAGED_PAGE_SETTINGS_SEEDED, SET_STAGED_PAGE_DATA
// @ts-expect-error not yet migrated
} from 'page-editor-ui/redux/actions/actionTypes';
const initialState = {
  domainName: null,
  status: null,
  previewUrl: null,
  seeded: false
};
const stagedPageReducer = (state = initialState, {
  type,
  payload
}) => produce(state, draft => {
  switch (type) {
    case SET_STAGED_PAGE_DATA:
      draft.domainName = payload.domainName;
      draft.status = payload.status;
      draft.previewUrl = payload.previewUrl;
      break;
    case MARK_STAGED_PAGE_SETTINGS_SEEDED:
      draft.seeded = true;
      break;
    default:
      break;
  }
});
export default stagedPageReducer;